export const THEME_TYPES_TO_CLASSNAME_MAPPING = {
  DEFAULT: 'featureSectionOneWrap',
  BG_BLACK__CLR_WHITE__CTABG_WHITE__CTACLR_BLACK: 'bgBlackColorWhiteTheme',
}
